import {
    LegacyFilmPlayerBaseInfoContent,
    LegacyVideoPlayerBaseInfoContent,
    SkippableFragment,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { filterFragments } from '../../movie-player/utils/filter-skippable-fragments';
import { EMPTY_FRAGMENTS } from '../../feature-player/constants/skin';

import { getFilmOtt } from './get-film-ott';

export function getFilmSkippableFragments(
    filmOrVideo:
        | LegacyFilmPlayerBaseInfoContent
        | LegacyVideoPlayerBaseInfoContent
        | undefined
        | null
): SkippableFragment[] {
    const filmOtt = filmOrVideo && getFilmOtt(filmOrVideo);
    const fragments = filmOtt?.onlineStreams?.streams?.[0]?.streamMeta?.skippableFragments;

    return fragments ? filterFragments(fragments) : EMPTY_FRAGMENTS;
}
